import { useState } from 'react'
import type { Workspace } from '../api/types'
import { useCurrentWorkspace } from '../hooks/useWorkspace'
import { useCreateWorkspace } from '../hooks/useWorkspaceData'
import { Button, ErrorNote, Field } from './ui'

export function CreateWorkspaceForm({ onCreated }: { onCreated?: (workspace: Workspace) => void }) {
  const [name, setName] = useState('')
  const create = useCreateWorkspace()
  const { select } = useCurrentWorkspace()
  return (
    <form
      className="stack"
      onSubmit={(event) => {
        event.preventDefault()
        create.mutate(
          { name: name.trim() },
          {
            onSuccess: (workspace) => {
              setName('')
              select(workspace.id)
              onCreated?.(workspace)
            },
          },
        )
      }}
    >
      <Field label="Name" hint="Usually the name of your show or company.">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="My community" maxLength={80} required />
      </Field>
      {create.error && <ErrorNote error={create.error} />}
      <div className="row">
        <Button type="submit" busy={create.isPending} disabled={!name.trim()}>Create workspace</Button>
      </div>
    </form>
  )
}
